import type { Marketplace } from "./types";

/** Display labels for each marketplace value. Single source of truth. */
export const MARKETPLACE_LABEL: Record<Marketplace, string> = {
  shopee: "Shopee",
  lazada: "Lazada",
  tiktok: "TikTok",
};
